module.exports = __webpack_public_path__ + "files/feba7c1dc363d25dc8a61f08483b369e.png";